<div id="angularRoot">
  <div fxLayout="column" style="position:-webkit-sticky;" fxShow="true" fxHide="false" id="0d95498c-3ea4-b533-fadb-6ae9bbc1d598">
    <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="a8d4641d-0ad5-0590-f174-26aa7a4eb0af">
      <h3 id="3100d40c-1320-c26d-d896-4545d7dfc92b" class="page-title">Dashboard Management</h3>
    </div>
    <div fxLayout="row" fxLayoutWrap="fxLayoutWrap" fxShow="true" fxHide="false" id="81ee8979-097d-8c3d-d1d1-73dc86a6dd39">
      <div fxLayout="column" fxShow="true" fxHide="false" id="28740e5b-0670-c61d-5c27-887ae726b2d6" fxFlex.xs="100">
        <mat-card id="31aae6ab-409b-573f-4714-a7e09ecfa5fd" class="app-card">
          <div fxLayout="row" fxShow="true" fxHide="false" id="37882008-f56d-5b3c-2304-1611291cef35">
            <div fxLayout="column" fxFlex="80" fxShow="true" fxHide="false" id="e55a7165-8df0-aff3-0dd9-abda6a6cfea4">
              <mat-card-subtitle id="39221581-f407-fe4f-a5b8-75be3a683d6e">Show me</mat-card-subtitle>
              <mat-card-title id="6f6e508a-e90c-c479-d698-f43aabbd7cd1">Call Center Inbound</mat-card-title>
            </div>
            <div fxLayout="column" fxFlex="20" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="b003e607-e9ff-59df-d184-697c0dbb8fb7">
              <div class="row press">
                <input type="checkbox" [(ngModel)]="subscribe.cci.access" id="one" class="cbx hidden">
                <label for="one" class="lbl label"></label>
              </div>
            </div>
          </div>
          <div fxLayout="row" id="b195e64e-a970-9ac5-934b-4d1864a78e51" [fxShow]="subscribe.cci.access">
            <p id="097cd628-0a7e-bd07-241d-beb585cacbc0" class="card-subheader-title">Alert me for events in </p>
          </div>
          <div fxLayout="column" id="b2472ece-5604-0c2a-a2ab-8ce92ae4428c" [fxShow]="subscribe.cci.access">
            <div fxLayout="row" fxShow="true" fxHide="false" id="0d406c01-b58a-3d91-4a4a-b40b0be244b1">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="abb60fa9-e735-769e-ef09-d3da1b7824c4">
                <p id="860b5838-4c59-6bda-d73b-41cf0f4df304">High</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="34a16a7e-188b-6487-1032-125d6e891c4b">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.cci.channels.high" id="four" class="cbx hidden">
                  <label for="four" class="lbl label1"></label>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="d291d7c1-da1a-96e1-5107-6387b825999e">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="8ee88038-910c-8b58-43a8-5613aa010c9a">
                <p id="b0bf2ea9-193e-702e-b37c-297247c30ff2">Medium</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="3c204d52-ff5c-d540-c54a-aed3efccf4d8">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.cci.channels.medium" id="five" class="cbx hidden">
                  <label for="five" class="lbl label1"></label>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="382cbd1e-d958-4ea5-9ada-b50883419852">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="f5477d37-3f49-1ae8-9bd2-f5eb3b63ed63">
                <p id="274f3b5a-dc16-27cf-4acd-b15ebcdf7c1e">Low</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="1cfb4c32-1d88-0fbb-f3a6-ca705b3f5803">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.cci.channels.low" id="six" class="cbx hidden">
                  <label for="six" class="lbl label1"></label>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <div fxLayout="column" fxShow="true" fxHide="false" id="98f8ce3e-b1f4-44f7-a65f-363a6b5a4f3a" fxFlex.xs="100">
        <mat-card id="caeba6e1-a8ab-324f-47b0-9c0c437a5af8" class="app-card">
          <div fxLayout="row" fxShow="true" fxHide="false" id="27b571a3-9a80-66dd-e0f4-2c81167dbc98">
            <div fxLayout="column" fxFlex="80" fxShow="true" fxHide="false" id="5c24a30a-72d4-d5d8-6195-938a10a1c06c">
              <mat-card-subtitle id="97994f71-5ef3-4ac7-2089-1dfea679b4c5">Show me</mat-card-subtitle>
              <mat-card-title id="5ff755ca-1c83-2f5b-e3b8-9d2d0e57d9f0">Walk In Center</mat-card-title>
            </div>
            <div fxLayout="column" fxFlex="20" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="83714620-37e5-aedd-d895-6079cd2f2616">
              <div class="row press">
                <input type="checkbox" [(ngModel)]="subscribe.wic.access" id="two" class="cbx hidden">
                <label for="two" class="lbl label"></label>
              </div>
            </div>
          </div>
          <div fxLayout="row" id="b47b9227-110f-4f89-0899-0a5b0af6ecdc" [fxShow]="subscribe.wic.access">
            <p id="85a12677-4ad4-7b8c-1e21-b99119429beb" class="card-subheader-title">Alert me for events in</p>
          </div>
          <div fxLayout="column" id="91220c29-a7df-95d6-6d0d-be411a6775f5" [fxShow]="subscribe.wic.access">
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="47ee43cb-61e5-e35c-c4b3-38ad217d6619">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="8214f445-4c6a-cd37-28de-115fd78581de">
                <p id="1d6d5177-5a51-c525-2197-69b66c35ef58">High</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="3c48ca9c-0213-1a44-4ba7-bb085eef01f5">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.wic.channels.high" id="seven" class="cbx hidden">
                  <label for="seven" class="lbl label1"></label>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="30f95fad-30f9-aab3-da8f-af9d87a15d09">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="0b7dc3ed-90df-b348-4218-4e582865b4f5">
                <p id="1c35e53e-73cc-eea3-3675-ae1503646a76">Medium</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="9f302c00-e86a-df86-2e2a-538236feda88">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.wic.channels.medium" id="eight" class="cbx hidden">
                  <label for="eight" class="lbl label1"></label>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="ea9d1b32-dda4-5dd3-f6b7-4ae6e81cbbf1">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="9db80a4d-bf61-4f6c-fba3-c14ff0c6e3b4">
                <p id="cd5b1e89-f447-08a4-3653-b27e4fc201f3">Low</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="9e9b5bab-9ca2-29c5-0fa6-0d383e1c35a0">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.wic.channels.low" id="nine" class="cbx hidden">
                  <label for="nine" class="lbl label1"></label>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <div fxLayout="column" fxShow="true" fxHide="false" id="5a01c8e7-05d5-e48b-4ced-0dbb870b0475" fxFlex.xs="100" *ngIf="false">
        <mat-card id="b29542ed-bf91-294e-9b69-28b656b4e83e" class="app-card">
          <div fxLayout="row" fxShow="true" fxHide="false" id="f663f6dd-0d80-ac38-a24f-b95b8e83e929">
            <div fxLayout="column" fxFlex="80" fxShow="true" fxHide="false" id="4132d3c8-f73a-e12c-f002-f82fc2b1d6dd">
              <mat-card-subtitle id="99ef29c6-be93-15e3-6caf-bf7844ff4b90">Show me</mat-card-subtitle>
              <mat-card-title id="bc7adf48-8a78-bbff-c6ff-d1051159eaad">Social Sentiments</mat-card-title>
            </div>
            <div fxLayout="column" fxFlex="20" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="00fbaaa4-31e3-f3f5-b5f5-00992a4eaa7a">
              <div class="row press">
                <input type="checkbox" [(ngModel)]="subscribe.ss.access" id="three" class="cbx hidden">
                <label for="three" class="lbl label"></label>
              </div>
            </div>
          </div>
          <div fxLayout="row" id="192072f5-bd30-9d33-322b-b00621932b24" [fxShow]="subscribe.ss.access">
            <p id="7f27dfc1-9da9-e3dd-43ea-e2f2146d54fd" class="card-subheader-title">Alert me for events in</p>
          </div>
          <div fxLayout="column" id="30935f2e-af57-ca5b-f72a-decf84c1f769" [fxShow]="subscribe.ss.access">
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="8598cfdb-9786-080f-c833-38c9ff4d9d67">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="e2305eb0-d411-c5e1-122f-1dc048a48734">
                <p id="79c08cfb-b20a-6770-9fad-025ecb5e1322">High</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="71aa3869-a61a-c0ae-9876-11b1afd0d9ea">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.ss.channels.high" id="ten" class="cbx hidden">
                  <label for="ten" class="lbl label1"></label>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="ba6f6998-b6e7-b9c7-b88b-8b74981e7225">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="be850359-02df-b01b-a18c-4e7cc4eb5c44">
                <p id="112f512f-82f0-e888-0101-94c0bf43de3f">Medium</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="a0331427-a31d-59c7-b218-155ff5320e9e">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.ss.channels.medium" id="eleven" class="cbx hidden">
                  <label for="eleven" class="lbl label1"></label>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxShow="true" fxHide="false" id="bec9e3c5-f7a0-d493-66f3-42098fb4c00e">
              <div fxLayout="column" fxFlex="fxFlex" fxShow="true" fxHide="false" id="14769bcf-53c6-90d9-ff50-27aed136fb4d">
                <p id="123a28f7-251a-c944-bd03-83ea77a1fb68">Low</p>
              </div>
              <div fxLayout="column" fxFlex="fxFlex" fxLayoutAlign="center end" fxShow="true" fxHide="false" id="479a1702-30b2-5200-18df-a10e87d06eab">
                <div class="row press">
                  <input type="checkbox" [(ngModel)]="subscribe.ss.channels.low" id="12" class="cbx hidden">
                  <label for="12" class="lbl label1"></label>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/notificationComponent/notification.template.html